import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { cva } from 'class-variance-authority';
import { SearchIcon } from 'lucide-react';
import { memo, useEffect, useRef, useState } from 'react';
import { cn } from './utils/shadcn-utils';
const textboxVariants = cva('file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input flex h-9 w-full min-w-0 rounded-md border border-input-border bg-transparent px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm focus-within:border-ring focus-within:ring-ring focus-within:ring-[var(--focus-ring-width)] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive', {
    variants: {
        variant: {
            default: 'bg-input',
            muted: 'bg-muted border-0 focus-within:ring-ring'
        },
        textboxSize: {
            default: 'h-9 px-3 py-2',
            sm: 'h-7 px-1.5 py-0.8',
            lg: 'h-10 px-4 py-2.5'
        }
    },
    defaultVariants: {
        variant: 'default',
        textboxSize: 'default'
    }
});
export const Textbox = (props) => {
    // Destructure custom props from HTML input attributes
    const { leftSide, rightSide, extendedPlaceholder, lines, className, onChange, autoFocus, placeholder, variant, textboxSize, onEnter, ...inputProps } = props;
    const inputRef = useRef(null);
    const [hasValue, setHasValue] = useState(!!props.value);
    const handleChange = (e) => {
        setHasValue(e.target.value !== '');
        onChange?.(e);
    };
    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            onEnter?.(e);
        }
    };
    useEffect(() => {
        const timeoutId = setTimeout(() => {
            if (autoFocus) {
                inputRef.current?.focus();
            }
        }, 0);
        return () => {
            clearTimeout(timeoutId);
        };
    }, [autoFocus, extendedPlaceholder]);
    return (_jsxs("div", { className: cn(textboxVariants({ variant, textboxSize }), className), children: [leftSide, _jsxs(_Fragment, { children: [extendedPlaceholder && (_jsxs("div", { className: "relative w-full overflow-hidden", children: [!hasValue && (_jsx("div", { className: "absolute top-1/2 left-2 right-2 -translate-y-1/2 pointer-events-none text-muted-foreground truncate", children: extendedPlaceholder })), _jsx("input", { type: "text", className: "w-full h-full bg-transparent relative z-10 outline-none text-foreground placeholder:text-muted-foreground", onChange: handleChange, autoComplete: "off", onKeyDown: handleKeyDown, ...inputProps, ref: inputRef })] })), !extendedPlaceholder && (_jsx("input", { type: "text", placeholder: placeholder, className: "w-full h-full outline-0 bg-transparent text-foreground placeholder:text-muted-foreground", onChange: handleChange, autoComplete: "off", onKeyDown: handleKeyDown, ...inputProps, ref: inputRef }))] }), rightSide] }));
};
export const SearchTextbox = ({ placeholder, className, onChange, autoFocus, rightSide, extendedPlaceholder, variant, textboxSize, value }) => {
    return (_jsx(Textbox, { placeholder: placeholder, className: cn('w-full', className), onChange: onChange, value: value, extendedPlaceholder: extendedPlaceholder, autoFocus: autoFocus, variant: variant, textboxSize: textboxSize, leftSide: _jsx(SearchIcon, { className: "mr-3 ml-2 text-muted-foreground" }), rightSide: rightSide }));
};
export const SearchPlaceholderFragment = memo(({ children }) => {
    return _jsx("span", { className: "py-1 px-2 rounded-md bg-muted text-muted-foreground", children: children });
});
//# sourceMappingURL=Textbox.js.map